import React, { useEffect, useState, useCallback } from 'react';
import { Trans } from 'react-i18next';
import { useSelector } from 'react-redux';
import classes from './FeedbackModal.module.scss';
import { setWidgetIsOpen, setFeedbackSubmit, setEndChat } from '../../store/actions/general';
import { useDispatch } from 'react-redux';

import Modal from '../Modal/Modal';

const FeedbackModal = ({ isOpen, closeHandler, socket }) => {
    const { endChat } = useSelector(state => state.general);
    const [selectedFeedback, setSelectedFeedback] = useState({ feedback_modal_option_1: null, feedback_modal_option_2: null });
    const [isSubmitDisabled, setIsSubmitDisabled] =  useState(true);
    const dispatch = useDispatch();
    const thumbClick = (value, metric) => {
        setSelectedFeedback(prev => ({ ...prev, [metric]: prev[metric] === value ? null : value }));
    };

    useEffect(()=>{
        setIsSubmitDisabled(selectedFeedback.feedback_modal_option_1 === null && selectedFeedback.feedback_modal_option_2 === null? true : false)
    },[selectedFeedback])

    const skipHandler = useCallback(() => {
        socket.emit("send", {
            name: "save-feedback",
            parameters:
             {
                feedback_modal_option_1: null, 
                feedback_modal_option_2: null
             }
        });
        setTimeout(() => {
            dispatch(setFeedbackSubmit(true));
            dispatch(setWidgetIsOpen(false));
            dispatch(setEndChat(false))
            setSelectedFeedback(prev => ({
                ...prev,
                feedback_modal_option_1: null,
                feedback_modal_option_2: null
            }));
            dispatch(setFeedbackSubmit(false));
        }, 500);
      }, [dispatch, socket]);
      const submitHandler = useCallback(() => {
        socket.emit("send", {
            name: "save-feedback",
            parameters:
             {
                feedback_modal_option_1: selectedFeedback.feedback_modal_option_1, 
                feedback_modal_option_2: selectedFeedback.feedback_modal_option_2
             }
        });

        setTimeout(() => {
            dispatch(setFeedbackSubmit(true));
            dispatch(setWidgetIsOpen(false));
            // dispatch(setResetChat(true))
            dispatch(setEndChat(false))
            // dispatch(setMode("bot"))
            // dispatch(setSessionId(''))
            // dispatch(setMessages([]))
            // dispatch(setAlertIsOpen(true))
            setSelectedFeedback(prev => ({
                ...prev,
                feedback_modal_option_1: null,
                feedback_modal_option_2: null
            }));
            dispatch(setFeedbackSubmit(false));
        }, 500);  
    }, [dispatch, socket, selectedFeedback]);

    return (
        <Modal isOpen={isOpen && endChat} onClose={closeHandler} contentWidth={'60%'}>
            <div className={classes.FeedbackModalContainer}>
                <div className={classes.FeedbackModalInnerContainer}>
                    <h2 style={window.sutherland_variables.ui.feedback_styles.title || {}}>
                        <Trans i18nKey="feedback.title">Thank you for chatting with Servbank.</Trans>
                    </h2>
                    <div className={classes.FeedbackModalContent}>
                        <div className={classes.Ratings}>
                            <div className={classes.Label} style={window.sutherland_variables.ui.feedback_styles.content}>
                                <Trans i18nKey="feedback.feedback_questions1">Was Joy easy to understand and simple to navigate?</Trans>
                            </div>
                            <div className={classes.Thumbs}>
                                <div 
                                    className={`${classes.ThumbsUp} ${selectedFeedback.feedback_modal_option_1 === 'positive' ? classes.ThumbsUpSelected : ''}`} 
                                    onClick={() => thumbClick("positive", 'feedback_modal_option_1')} 
                                />
                                <div 
                                    className={`${classes.ThumbsDown} ${selectedFeedback.feedback_modal_option_1 === 'negative' ? classes.ThumbsDownSelected : ''}`} 
                                    onClick={() => thumbClick("negative", 'feedback_modal_option_1')} 
                                />
                            </div>
                        </div>
                        <div className={classes.Ratings}>
                            <div className={classes.Label} style={window.sutherland_variables.ui.feedback_styles.content}>
                                <Trans i18nKey="feedback.feedback_questions2">Was your inquiry resolved in this chat session?</Trans>
                            </div>
                            <div className={classes.Thumbs}>
                                <div 
                                    className={`${classes.ThumbsUp} ${selectedFeedback.feedback_modal_option_2 === 'positive' ? classes.ThumbsUpSelected : ''}`} 
                                    onClick={() => thumbClick("positive", 'feedback_modal_option_2')} 
                                />
                                <div 
                                    className={`${classes.ThumbsDown} ${selectedFeedback.feedback_modal_option_2 === 'negative' ? classes.ThumbsDownSelected : ''}`} 
                                    onClick={() => thumbClick("negative", 'feedback_modal_option_2')} 
                                />
                            </div>
                        </div>
                        <div className={classes.Buttons}>
                            <button 
                                className={classes.ButtonFeedback} 
                                style={window.sutherland_variables.ui.feedback_styles.button} 
                                onClick={submitHandler} 
                                onMouseEnter={(e) => Object.assign(e.target.style, window.sutherland_variables.ui.feedback_styles.button_hover)}
                                onMouseLeave={(e) => Object.assign(e.target.style, window.sutherland_variables.ui.feedback_styles.button)}
                                disabled={isSubmitDisabled}
                            >
                                <Trans i18nKey="feedback.submit_btn">Submit</Trans>
                            </button>
                        </div>
                        <div className={classes.ButtonSkip}>
                            <button onClick={skipHandler} style={window.sutherland_variables.ui.feedback_styles.skip_button}>
                                <Trans i18nKey="feedback.skip_btn">Skip</Trans>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default FeedbackModal;
